import { useCallback, useContext } from 'react';
import { useHistory } from 'react-router';
import { ToastContext } from 'contexts';
import { useAuth } from 'providers/AuthProvider';
import useCreateToken from './useCreateToken';
import useCreateSubscription from './useCreateSubscription';

export default () => {
  const history = useHistory();
  const createTokenMutation = useCreateToken();
  const createSubscriptionMutation = useCreateSubscription();
  const { logout } = useAuth();
  const { triggerToast } = useContext(ToastContext);

  if (createSubscriptionMutation.isSuccess) {
    logout();
    history.push('/subscribe/success', {
      email: createSubscriptionMutation.data.email,
    });
  }

  const doSubscribe = useCallback(
    async ({ billingInfo, subscriptionInfo }) => {
      const stripeToken = await createTokenMutation.mutateAsync(billingInfo).catch(err => {
        triggerToast(err.message);
        return null;
      });

      if (stripeToken) {
        createSubscriptionMutation.mutate({ stripeToken, ...subscriptionInfo });
      }
    },
    [createTokenMutation, createSubscriptionMutation, triggerToast]
  );

  return [
    {
      data: createSubscriptionMutation.data,
      isSuccess: createTokenMutation.isSuccess && createSubscriptionMutation.isSuccess,
      isLoading: createTokenMutation.isLoading || createSubscriptionMutation.isLoading,
      isError: createTokenMutation.isError || createSubscriptionMutation.isError,
      error: createTokenMutation.error || createSubscriptionMutation.error,
    },
    doSubscribe,
  ];
};
